import script from "./GroupElement.vue?vue&type=script&lang=js"
export * from "./GroupElement.vue?vue&type=script&lang=js"

import "./GroupElement.vue?vue&type=style&index=0&id=c9c74868&lang=scss"

const __exports__ = script;

export default __exports__